module.exports = __webpack_public_path__ + "static/media/Lee-Ackerman.b844eaf0.jpg";